import {Component} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {faCopy} from '@fortawesome/pro-duotone-svg-icons';
import {ButtonTypeEnum, IspColoursEnum} from '@i-supplier/angular-shared-module';
import {AuthenticationService} from '../../../core/services/authentication.service';

@Component({
  selector: 'electronic-invoicing-info-modal',
  templateUrl: './electronic-invoicing-info-modal.component.html',
  styleUrls: ['./electronic-invoicing-info-modal.component.scss']
})
export class ElectronicInvoicingInfoModalComponent {
  protected readonly faCopy = faCopy;
  protected readonly ButtonTypeEnum = ButtonTypeEnum;
  protected readonly IspColoursEnum = IspColoursEnum;
  readonly electronicAddress = '840719355_10_PLT';
  readonly contactEmail = 'help@isupplier.fr';
  submitting = false;

  constructor(
    public modalRef: BsModalRef,
    private authService: AuthenticationService,
  ) {}

  copyAddress(): void {
    navigator.clipboard?.writeText(this.electronicAddress);
  }

  acknowledge(): void {
    if (this.submitting) {
      return;
    }
    this.submitting = true;
    this.authService.acceptElectronicInvoicingInfo().subscribe({
      next: () => {
        this.modalRef.hide();
      },
      error: () => {
        this.submitting = false;
      }
    });
  }
}
